import React, { useEffect } from 'react'
import ReactPixel from 'react-facebook-pixel'
import { completeRegistrationTrack } from '../utils/metaAd'

interface AnalyticsProviderProps {
  userType?: string | null
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ userType }) => {

  useEffect(() => {
    const options = {
      autoConfig: true,
      debug: true,
    }

    ReactPixel.init(
      process.env.REACT_APP_META_AD_KEY
        ? process.env.REACT_APP_META_AD_KEY
        : '',
      undefined,
      options
    )
    ReactPixel.pageView()

    if (typeof window.gtag === 'function') {
      window.gtag('config', 'AW-677452397')
    } else {
      console.error('gtag is not defined')
    }
  }, [])

  useEffect(() => {
    const userTypeBool = userType === 'true' ? true : false
    if (userTypeBool) {
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-677452397/x4ZgCKzB3IwaEO20hMMC',
          value: 1.0,
          currency: 'KRW',
        })
      } else {
        console.error('gtag is not defined')
      }
      completeRegistrationTrack()
    }
  }, [userType])

  return null
}